import React from "react";
import Buypagestepone from "Pages/Buy";


const Buytheme = () => {
  return (
    <React.Fragment>
       <Buypagestepone/>
    </React.Fragment>
  );
};

export default Buytheme;
